var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Provider } from 'mobx-react';
import React, { useState } from 'react';
import ThemeProvider from '../ui/themes/themeProvider/ThemeProvider';
import BottomSheetStore from '../ui/uiElements/advanced/bottomSheet/dataLayer/stores/BottomSheetStore';
import ContextMenuStore from '../ui/uiElements/advanced/contextMenu/dataLayer/stores/ContextMenuStore';
import IconResolverContext from '../ui/uiElements/advanced/icon/context/IconResolverContext';
import ModalStore from '../ui/uiElements/advanced/modal/dataLayer/stores/ModalStore';
import SidebarStore from '../ui/uiElements/advanced/sidebar/dataLayer/stores/SidebarStore';
var ReactBaseProvider = function (_a) {
    var theme = _a.theme, iconResolver = _a.iconResolver, children = _a.children, sidebarKeys = _a.sidebarKeys;
    var _b = __read(useState(ContextMenuStore.create()), 1), contextMenuStore = _b[0];
    var _c = __read(useState(sidebarKeys ? SidebarStore(sidebarKeys).create() : undefined), 1), sidebarStore = _c[0];
    var _d = __read(useState(ModalStore.create()), 1), modalStore = _d[0];
    var _e = __read(useState(BottomSheetStore.create()), 1), bottomSheetStore = _e[0];
    return (React.createElement(IconResolverContext.Provider, { value: iconResolver },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(Provider, { contextMenuStore: contextMenuStore, sidebarStore: sidebarStore, modalStore: modalStore, bottomSheetStore: bottomSheetStore }, children))));
};
export default ReactBaseProvider;
//# sourceMappingURL=ReactBaseProvider.js.map